module.exports = {"signature":{"title":"An iDalgo product"}}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en.json
// module id = yZm8
// module chunks = 1